import React from 'react';
import PropTypes from 'prop-types';

import styles from './MainList.css';

import { MainItem } from './MainItem';

const MainList = ({ navigationItems, toggleMenu }) => (
  <ul className={styles.main}>
    {navigationItems.map((item) => (
      <MainItem
        item={item}
        key={item.key}
        onClick={
          // Only Menu button has to handle popOver action
          item.key === 'more' ? toggleMenu : undefined
        }
      />
    ))}
  </ul>
);

MainList.propTypes = {
  navigationItems: PropTypes.array.isRequired,
  toggleMenu: PropTypes.func.isRequired,
};

export { MainList };
